export default __webpack_public_path__ + "static/media/abstracto11440.8cc4c6c8.jpg";